import { useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';
import { RootState } from '../../../../store/store';
import { ESME_FORM_NAME } from '../../../../store/form/formStateModel';
import React, { useEffect, useState } from 'react';
import EsmeApi from '../../../../api/esmeApi';
import ConfigFileViewer from '../../../../shared/components/ConfigFileViewer';
import { EsmeDataForm } from '../../components/esme/EsmeForm';
import { VersionableId } from '../../../../types/versionableId';
import { AppErrorList, useAppErrorList } from '../../../../shared/components/AppErrorList';

type Props = {
  readonly esmeId?: VersionableId;
  readonly readOnly: boolean;
};

const EsmeConfigFilePreviewContainer = (props: Props) => {
  const { esmeId, readOnly } = props;

  const [isLoading, setLoading] = useState<boolean>(false);
  const [configFile, setConfigFile] = useState<string | undefined>();

  const [{ errors, hasErrors }, { addError, removeError }] = useAppErrorList();
  const esmeDataForm = useSelector((state: RootState) => getFormValues(ESME_FORM_NAME)(state)) as EsmeDataForm;

  useEffect(() => {
    if (esmeId) {
      setLoading(true);

      EsmeApi.fetchEsmeConfigFile(esmeId)
        .then(setConfigFile)
        .catch(addError)
        .finally(() => setLoading(false));
    }
  }, [addError, esmeId]);

  useEffect(() => {
    if (!readOnly) {
      setLoading(true);

      EsmeApi.generateEsmeConfigFilePreview(esmeDataForm)
        .then(setConfigFile)
        .catch(addError)
        .finally(() => setLoading(false));
    }
  }, [addError, readOnly, esmeDataForm]);

  return (
    <>
      { hasErrors ? (
        <AppErrorList
          errors={errors}
          onCloseError={removeError}
        />
      ) : (
        <ConfigFileViewer
          isGenerating={isLoading}
          content={configFile}
        />
      )}
    </>
  );
};

export default EsmeConfigFilePreviewContainer;
